module.exports = __webpack_public_path__ + "static/media/21-3.8be2c8af.mp3";